import React from "react";
import { renderFittingPdf } from "../../PDF/Shared/renderFittingPdf";
import DamnPdfDocument, { DAMN_PDF_DENSITIES, DamnPdfData, DamnPdfDensity } from "./damnPdfDocument";
import { DamnPdfInclude } from "./damnPdfOptions";

// The preview and the download both come from here, so what's previewed is exactly what's saved. Very long route steps
// can still run onto a second page at the densest setting.
export const renderDamnPdf = (data: DamnPdfData, include: DamnPdfInclude): Promise<Blob> =>
    renderFittingPdf(
        (density, onPageCount) => (
            <DamnPdfDocument
                data={data}
                include={include}
                density={density as DamnPdfDensity}
                onPageCount={onPageCount}
            />
        ),
        DAMN_PDF_DENSITIES.length
    );
